var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "additional-load",
      class: {
        "additional-load-red":
          _vm.record.additionalLoad.value > 10 &&
          _vm.record.postCode === "driver",
        "additional-load-green":
          _vm.record.additionalLoad.value < 10 &&
          _vm.record.postCode === "driver",
        "additional-load-grey":
          _vm.record.additionalLoad.value.length === 0 &&
          _vm.record.postCode === "driver",
      },
    },
    [
      _vm.record.postCode === "driver"
        ? _c("div", { staticClass: "additional-load-driver-desc" }, [
            _vm._v("Время без дела:"),
          ])
        : _vm._e(),
      _vm.record.postCode === "driver"
        ? _c("div", { staticClass: "additional-load-driver-value" }, [
            _vm._v(" " + _vm._s(_vm.record.additionalLoad.value) + "% "),
          ])
        : _vm._e(),
      _vm.record.postCode === "suhi"
        ? _c("div", { staticClass: "additional-load-suhi-desc" }, [
            _vm._v("Лосось, кг"),
          ])
        : _vm._e(),
      _vm.record.postCode === "suhi"
        ? _c(
            "div",
            { staticClass: "additional-load-suhi-value" },
            [
              _c("c-input", {
                staticClass: "additional-load-suhi-value-input",
                attrs: { placeholder: "0", type: "price-number" },
                model: {
                  value: _vm.suhiAdditionalLoadValue,
                  callback: function ($$v) {
                    _vm.suhiAdditionalLoadValue = $$v
                  },
                  expression: "suhiAdditionalLoadValue",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }